import type { UserRole } from '../api/types'

/**
 * Режим разработки: обход проверки подписки Telegram в ЛК.
 * В production по умолчанию выключен; локально — включён, пока не задано VITE_DEV_MODE=false.
 */
export const isDevMode =
  import.meta.env.VITE_DEV_MODE === 'true'
  || (import.meta.env.DEV && import.meta.env.VITE_DEV_MODE !== 'false')

const parsePositiveInt = (raw: string | undefined): number | null => {
  if (!raw) {
    return null
  }
  const value = Number.parseInt(raw, 10)
  return Number.isFinite(value) && value > 0 ? value : null
}

export const devBuyerOrgId = (): number | null =>
  parsePositiveInt(import.meta.env.VITE_DEV_BUYER_ORG_ID)
    ?? parsePositiveInt(import.meta.env.VITE_DEV_RESTAURANT_ORG_ID)
    ?? parsePositiveInt(import.meta.env.VITE_DEV_ORGANIZATION_ID)

/** @deprecated use devBuyerOrgId */
export const devRestaurantOrgId = devBuyerOrgId

export const devSupplierOrgId = (): number | null =>
  parsePositiveInt(import.meta.env.VITE_DEV_SUPPLIER_ORG_ID)

export const devRfqId = (): number | null => parsePositiveInt(import.meta.env.VITE_DEV_RFQ_ID)

export const devOrganizationId = (): number | null => devBuyerOrgId()

export const devSecret = (): string | null => {
  const secret = import.meta.env.VITE_MINIAPP_DEV_SECRET?.trim()
  return secret ? secret : null
}

export const devOrgIdForRole = (role: UserRole): number | null =>
  role === 'supplier' ? devSupplierOrgId() : devBuyerOrgId()

export const devCounterpartyOrgIdForRole = (role: UserRole): number | null =>
  role === 'supplier' ? devBuyerOrgId() : devSupplierOrgId()
